import React, { useCallback, useLayoutEffect, useState } from 'react';
import qs from 'query-string';

import Envelope from 'app/components/common/Envelope';

import styles from './EnvelopePreview.module.css';

interface IHash {
  n?: string,
  c1?: string,
  c2?: string,
  c3?: string,
  c4?: string,
  c5?: string,
  l?: string,
  b?: string,
}

const init = {
  n: 'Sender Name',
  c1: '',
  c2: '',
  c3: '',
  c4: '',
  c5: '',
  l: '',
  b: '',
};

const EnvelopePreview: React.FC = () => {
  const handleTapToOpen = useCallback(() => true, []);
  const [name, setName] = useState(init.n);
  const [colors, setColors] = useState([init.c1, init.c2, init.c3, init.c4, init.c5]);
  const [logo, setLogo] = useState(init.l);
  const [background, setBackground] = useState(init.b);

  const parseHash = (hash: string) => {
    const results: IHash = qs.parse(hash);
    setName(results.n || init.n);
    const {
      c1, c2, c3, c4, c5, b,
    } = results;
    setColors([c1 || init.c1, c2 || init.c2, c3 || init.c3, c4 || init.c4, c5 || init.c5]);
    setLogo(results.l || init.l);
    setBackground(b || init.b);
  };

  const handleHashChange = useCallback(() => parseHash(window.location.hash), []);

  useLayoutEffect(() => {
    window.addEventListener('hashchange', handleHashChange, false);
    handleHashChange();
    return () => {
      window.removeEventListener('hashchange', handleHashChange, false);
    };
  }, [handleHashChange]);

  return (
    <div className={styles.wrapper}>
      <Envelope
        colors={colors}
        cardState="closed"
        cardStatus="ready"
        senderName={name}
        handleTapToOpen={handleTapToOpen}
        logo={logo}
        background={background}
        isCustom={Boolean(colors[0])}
      />
    </div>
  );
};

export default EnvelopePreview;
